// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

export const environment = {
  production: false,
  
	accountUrl:'https://stg-account.scora.io/',
	authorUrl:'https://stg-author.scora.io/',
	userDashboardUrl:'https://stg-participant.scora.io/',
	testEngineUrl:'https://stg-testengine.scora.io/',
	appUrl: 'http://localhost:5500',
	uiHost: 'scora.io',

//Local
	// accountUrl:'http://localhost:5200',
	// authorUrl:'http://localhost:5300',
	// userDashboardUrl:'http://localhost:5400',
	// testEngineUrl:'http://localhost:5600',
	// appUrl:'http://localhost:5500',
	// uiHost:'localhost',
  
    host:'https://stg-api.scora.io/scora.io/backend/scoraauthor/public/api',	
	authorHost:'https://stg-api.scora.io/scora.io/backend/scoraauthor/public/api',
	userdashboardHost:'https://stg-api.scora.io/scora.io/backend/scoraauthor/public/api',
	userHost:'https://stg-api.scora.io/scora.io/backend/scorauser/public/api',	
	accountHost:'https://stg-api.scora.io/scora.io/backend/scoraaccounts/public/api', 
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts